module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/root/root.component.scss
// module id = ./src/app/root/root.component.scss
// module chunks = main